module.exports = __webpack_public_path__ + "img/Badge_GOLD.ac7b494d.png";